import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ba50e02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "user-info"
}
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "email" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-align-justify cursor-pointer" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "nav-menu" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "icon" }
const _hoisted_10 = {
  key: 0,
  class: "label-text"
}
const _hoisted_11 = { class: "icon" }
const _hoisted_12 = {
  key: 0,
  class: "label-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sidebar", { isClosed: _ctx.isClosed }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["menu-wrapper-header", { isClosed: _ctx.isClosed }])
      }, [
        (_ctx.isSignedIn && !_ctx.isClosed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.userData.fullName), 1),
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.userData.email), 1),
              _createElementVNode("div", {
                class: "name profile cursor-pointer",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigateToProfile && _ctx.navigateToProfile(...args)))
              }, _toDisplayString(_ctx.$t('user.profile')), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "sidebar-toggler",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleMenu()))
        }, _hoisted_6)
      ], 2),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["nav-item cursor-pointer", { active: item.isActive }]),
            key: item.title,
            onClick: ($event: any) => (_ctx.processMenuItemClick(item))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["label no-hover", { 'label-xs': _ctx.isClosed }])
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_fa, {
                  icon: item.class
                }, null, 8, ["icon"])
              ]),
              (!_ctx.isClosed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t(item.title)), 1))
                : _createCommentVNode("", true)
            ], 2)
          ], 10, _hoisted_8)), [
            [_directive_tooltip, _ctx.isClosed ? _ctx.$t(item.title) : '']
          ])
        }), 128)),
        (_ctx.isSignedIn)
          ? _withDirectives((_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "nav-item cursor-pointer",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args)))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["label no-hover", { 'label-xs': _ctx.isClosed }])
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_fa, { icon: "icon fa-sign-out" })
                ]),
                (!_ctx.isClosed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('navMenu.signOut')), 1))
                  : _createCommentVNode("", true)
              ], 2)
            ])), [
              [_directive_tooltip, _ctx.isClosed ? _ctx.$t('navMenu.signOut') : '']
            ])
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}